import type { ModuleManifest } from '@botto/core';
import { routes } from './routes';
import { menu } from './menu';

const manifest: ModuleManifest = {
  id: 'cdp',
  title: 'CDP',
  routes,
  menu,
};

export default manifest;
